module.exports = __webpack_public_path__ + "img/21_4.b05d6af5.png";